import { CircularProgress, Typography, Box } from '@mui/material';

function Loader() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '150px',
      }}
    >
      <CircularProgress />
      <Typography variant="body2" mt={2}>
        Загрузка данных...
      </Typography>
    </Box>
  );
}

export default Loader;
